'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getReviewsStarIcon = exports.formatProductPriceMeasurements = undefined;

var _functional = require('../utils/functional');

/**
 * Formats the Unit Price Measurment of a product into a common string
 *
 * @param {number} productPrice
 * @param {Object} unitPriceMeasurement
 *
 * @returns {String}
 */
var formatProductPriceMeasurements = exports.formatProductPriceMeasurements = function formatProductPriceMeasurements(productPrice, unitPriceMeasurement) {
  var includeQuantityValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  if (!unitPriceMeasurement) return null;

  var quantityValue = parseFloat(unitPriceMeasurement.quantity_value);
  var pricePerQuantity = productPrice / quantityValue * 100;
  var baseQuantity = unitPriceMeasurement.reference_value > 1 ? unitPriceMeasurement.reference_value : '';

  if (unitPriceMeasurement.reference_unit === 'l' || unitPriceMeasurement.reference_unit === 'kg') {
    pricePerQuantity = pricePerQuantity * 10;
  }

  var productPriceMeasurements = (0, _functional.formatMoney)(pricePerQuantity) + '/' + baseQuantity + unitPriceMeasurement.reference_unit;

  if (includeQuantityValue) {
    productPriceMeasurements = '' + parseFloat(unitPriceMeasurement.quantity_value) + unitPriceMeasurement.quantity_unit + ' (' + productPriceMeasurements + ')';
  }

  return productPriceMeasurements;
};

/**
 * Gets the correct Star icon depending on the product rating
 *
 * @param {number} rating - The products rating
 *
 * @returns {String}
 */
var getReviewsStarIcon = exports.getReviewsStarIcon = function getReviewsStarIcon(rating) {
  var iconNamePrefix = 'am-icon-star-';
  var iconNameSuffix = void 0;

  if (rating > 1 && rating <= 2) {
    iconNameSuffix = 'quarter';
  } else if (rating > 2 && rating <= 3) {
    iconNameSuffix = 'half';
  } else if (rating > 3 && rating <= 4) {
    iconNameSuffix = 'three-quarters';
  } else {
    iconNameSuffix = 'full';
  }

  return '' + iconNamePrefix + iconNameSuffix;
};